import React from "react";
import { useNavigate } from "react-router-dom";

const HomeDashboard = () => {
  const authState = JSON.parse(localStorage.getItem("auth0-token-storage"));
  const navigate = useNavigate();

  const handleExpiration = () => {
    localStorage.removeItem("auth0-token-storage");
    localStorage.removeItem("user-claims");
    navigate("/login", { replace: true });
  };

  return !authState.access_token ? (
    handleExpiration()
  ) : (
    <div className="container-fluid py-4 mt-3">
      <h1>Please clock in to view appointments</h1>
    </div>
  );
};

export default HomeDashboard;
